<template>
  <div class="containerHome">
    <div
      class="unitTItle"
      v-show="
        $store.state.user.userInfo.natureId == 1 ||
          $store.state.user.userInfo.natureId == 3 ||
          $store.state.user.userInfo.natureId == 4
      "
    >
      <div class="common-page common-head">
        <div class="common-page common-head-title">
          <i class="icon-tr--detailed" style="padding-right: 5px"></i>
          数据分析
        </div>
      </div>
    </div>
    <div class="containertContent">
      <!-- <el-divider></el-divider> -->
      <div
        class="unitList"
        style="background-color: #fff;"
        v-show="
          $store.state.user.userInfo.natureId == 1 ||
            $store.state.user.userInfo.natureId == 3 ||
            $store.state.user.userInfo.natureId == 4
        "
      >
        <unitList
          @select="getUnit"
          @getFirst="getOne"
          @getFirstNmae="getName"
          :companyNum="companyNum"
          :companyName="companyName"
        ></unitList>
      </div>
      <div :style="natureid1 ? 'width:80%' : 'width:100%'">
        <!-- <div v-if="$store.state.user.userInfo.natureId == 2"> -->
        <div
          class="item1 selectName"
          v-if="$store.state.user.userInfo.natureId == 2"
        >
          <!-- this.userInfo.cName || "请选择单位" -->
          <h2>{{ swiLength>1?(swiItem1.relicName||'请选择单位'):(this.userInfo.cName || "请选择单位") }}</h2>
          <!-- <div>{{ this.companyName }}</div> -->
        </div>
        <div class="item1 selectName xiahuaxian" v-else>
          <h2
            class="item1 selectName"
            v-if="this.$route.query.name || switchUnit"
          >
            {{ companyName||this.$route.query.name || "请选择单位1111" }}
            <!-- companyName -->
          </h2>
          <h2 class="item1 selectName" v-else>{{ company || "请选择单位" }}</h2>
        </div>
        <div class="buju">
          <div class="fisrbase">
            <h3 class=" mt0">基本信息</h3>
            <div class="item2">
              <div style="margin-left:5px;padding-bottom:15px">
                <h3>类别</h3>
                <p class="ziyanse buhuanh" :title="titleName">
                  {{swiLength>1?swiItem1Type:formType}}
                </p>
                <h3>级别</h3>
                <p class="ziyanse buhuanh">
                  {{swiLength>1?swiItem1relicRank:formRelicRank}}
                </p>
              </div>
              <img
                src="@/assets/img/wenlvIndex.png"
                alt=""
                style="width:80px;height:80px;margin-right:30px"
              />
            </div>
          </div>
          <div class="item3">
            <h3 class=" mt0">报警概览</h3>
            <reportAlarm :cpNum="cpNum"></reportAlarm>
          </div>
        </div>
       
        <div class="zhongjian">
          <div class="wenzi">
            <h3>简介</h3>
            <p class="shengluehao">{{ swiLength>1?swiItem1intro:formintro }}</p>
          </div>
          <div class="dataChartList">
            <div class="device">
              <h3 class="">单位各类设备数量统计</h3>
              <div class="deviceList">
                <div style="" class="hangzong">
                  <p :title="'无线烟感'" class="buhuanh">无线烟感</p>
                  <p
                    
                    class="bjtc"
                  >
                    {{ deviceCountGroupTypeList.smokeSensationCount || 0 }}
                  </p>
                </div>
                <div class="hangzong">
                  <p
                    :title="'水位探测器'"
                    class="cursor buhuanh"
                    id="waterLevel"
                  >
                    水位探测器
                  </p>
                  <p
                    :title="deviceCountGroupTypeList.waterPositionCount || 0"
                    class="bjtc"
                  >
                    {{ deviceCountGroupTypeList.waterPositionCount || 0 }}
                  </p>
                </div>
                <div style="" class="hangzong">
                  <p :title="'电气监测'" class="buhuanh">电气监测</p>
                  <p
                    :title="deviceCountGroupTypeList.electricalCount || 0"
                    class="bjtc"
                  >
                    {{ deviceCountGroupTypeList.electricalCount || 0 }}
                  </p>
                </div>
                <div style="" class="hangzong">
                  <p :title="'水压探测器'" class="buhuanh">水压探测器</p>
                  <p
                    :title="deviceCountGroupTypeList.waterPressureCount || 0"
                    class="bjtc"
                  >
                    {{ deviceCountGroupTypeList.waterPressureCount || 0 }}
                  </p>
                </div>
                <div style="display:flex" class="hangzong">
                  <p :title="'用传'" class="buhuanh">用传</p>
                  <p
                    :title="deviceCountGroupTypeList.transmissionCount || 0"
                    class="bjtc"
                  >
                    {{ deviceCountGroupTypeList.transmissionCount || 0 }}
                  </p>
                </div>
                <div style="display:flex" class="hangzong">
                  <p
                    :title="'视频监控'"
                    class="cursor visited buhuanh"
                    id="watchVideo"
                  >
                    视频监控
                  </p>
                  <p
                    :title="deviceCountGroupTypeList.monitorCount || 0"
                    class="bjtc"
                  >
                    {{ deviceCountGroupTypeList.monitorCount || 0 }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="zhongjian">
          <div>
            <h3>照片</h3>
            <div style="display:flex;flex-wrap: wrap; border: 1px solid rgb(33, 150, 243);" v-if="imgsrc.length>0">
              <img
                :src="item"
                alt=""
                v-for="item in imgsrc"
                class="zhaoPhoto"
              />
            </div>
            <div class="zhaoPhoto"  style="display:flex;flex-wrap: wrap; border: 1px solid rgb(33, 150, 243);" v-else>
             暂无数据
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { alarmOverview, deviceCountGroupType } from "@/api/report.js";
// 组件
import unitList from "@/components/unitList";
import reportScore from "./unitPage/report-score.vue";
import reportAlarm from "./unitPage/report-alarmOverview.vue";
import reportTrend from "./unitPage/report-fireTrend.vue";
import reportWaterSystem from "./unitPage/report-waterSystem.vue";
import reportVideo from "./unitPage/report-video.vue";
import reportCrt from "./unitPage/report-crt.vue";
export default {
  components: {
    unitList,
    reportScore,
    reportAlarm,
    reportTrend,
    reportWaterSystem,
    reportVideo,
    reportCrt,
  },
  data() {
    return {
      cpNum: this.$store.state.user.company.cCompanyNum||'',
      company: "",
      companyNum: this.$route.query.companyNum || "",
      companyName: this.$route.query.name||'',
      c_company_num: this.$local.get("company")?.c_company_num || "",
      switchUnit: false,
      reportUnit: false,
      userInfo: {},
      form: {
        type:0,
        relicRank:0,
        intro:''
      },
      formType:'',
      deviceCountGroupTypeList: {},
      imgsrc: [],
      titleName: "",
      natureid1: null,
      roleIdListStr: null,
      swi: [],
      swiLength:0,
      swiItem1: {
         type:0,
        relicRank:0,
        intro:''
      },
      swiItem1Type:'',
      swiItem1relicRank:'',
      formRelicRank:'',
      swiItem1intro:'',
      formintro:''
    };
  },
  watch: {
    cpNum() {
      this.getDeviceCountGroupType();
      if (this.$local.get("company")) {
        this.company = this.$local.get("company").c_name;
        this.cpNum = this.$local.get("company").c_company_num;
      }

      if (this.$route.query.name) {
        this.switchUnit = true;
      } else if (!this.$route.query.name) {
        this.switchUnit = false;
        this.reportUnit = true;
      }
      // console.log(company,7777777777777777);
    },
    
    // swiItem(){
    //   console.log('shujubianh');
    //   // this.$delete(this.swiItem)
    //   this.$set(this.swiItem1)
    //   this.$forceUpdate()
    // }
  },
  created() {},
  mounted() {


    if (this.$store.state.user.userInfo.natureId == 1 || 3 || 4) {
      this.natureid1 = true;
    } else {
      this.natureid1 = false;
    }

    if (this.$store.state.user.userInfo.natureId == 2 || 3) {
      this.$store.dispatch("GetInfo").then((res) => {
        // log(res, 111);
        if (res.companyBase) {
          console.log('you');
          this.userInfo = res.companyBase;

          this.cpNum = res.companyBase.cCompanyNum || "";
          this.company = res.companyBase.cName;
           
        }
      });
    }
        this.roleIdListStr = this.$local.get("userInfo").roleIdListStr;

    if (this.$store.state.user.userInfo.natureId == 2) {
      this.$get(
        "relic/relicInspectionArchives/dataAnalyzeHomePage/" +
          this.cpNum
      ).then((res) => {
        this.swi = res.data;
         if (res.data==null) {
            this.restData()
          }else{
            this.swiLength=res.data.length
        this.timerlun()
          }
        
        
      });
    }
 this.getDeviceCountGroupType()
 console.log(this.companyName,'333333333433333');
       
      // console.log(this.cpNum,'this.cpNum');
    
      // deviceCountGroupType({ companyNum: this.cpNum }).then((res) => {
      //   // console.log(res, 66666);
      //   this.deviceCountGroupTypeList = res.data;
      // });
    
  },

  methods: {
    timerlun(){
      let i = 0;
        this.swiItem1 = this.swi[i];
      this.swichongzhi()
     
          // this.$set(this.swiItem1)swiItem1relicRank
          // this.imgsrc=[]
          // if (this.swiItem1.photo) {
          //   this.imgsrc = this.swiItem1.photo.split(",");
          // }
          
        let t = setInterval(() => {
          i += 1;
          if (i >= this.swi.length) {
            clearInterval(t);
            // this.timerlun()
          }
          // console.log(this.swi[i],i,this.swi);
          // this.swiItem1 = JSON.parse(JSON.stringify(this.swi[i]));
          this.swiItem1 = this.swi[i];
          if (this.swiItem1.type == 2) {
            this.titleName = "近现代重要史迹及代表性建筑";
          } else {
            this.titleName == "";
          }
          this.swichongzhi()
          // this.$set(this.swiItem1)
          // this.imgsrc=[]
          // if (this.swiItem1.photo) {
          //   this.imgsrc = this.swiItem1.photo.split(",");
          // }
          
        }, 15000);
    },
    shijian(){

    },
    swichongzhi(){
      console.log(this.swiItem1);
      this.restData()
      console.log(this.swiItem1);

          if( this.swiItem1.type == 1){
          this.swiItem1Type="古建筑"
        }else if(this.swiItem1.type == 2){
           this.swiItem1Type="近现代重要史迹及代表性建筑"
        }else if(this.swiItem1.type == 3){
           this.swiItem1Type="古墓葬"
        }else if(this.swiItem1.type == 4){
             this.swiItem1Type="石窟寺及石刻"
          
        }else if(this.swiItem1.type == 5){
           this.swiItem1Type="古遗址"
        }else{
          this.swiItem1Type="其它"
        }
        if( this.swiItem1.relicRank == 1){
          this.swiItem1relicRank="全国重点"
        }else if(this.swiItem1.relicRank == 2){
           this.swiItem1relicRank="省级"
        }else if(this.swiItem1.relicRank == 3){
           this.swiItem1relicRank="青岛市级"
        }else if(this.swiItem1.relicRank == 4){
           this.swiItem1relicRank="平度市级"
        }else{
          this.swiItem1relicRank="其它"
        }
        if (this.swiItem1.photo) {
            this.imgsrc = this.swiItem1.photo.split(",");
          }
        this.swiItem1intro= this.swiItem1.intro
        // this.$set(this.swiItem1intro)
    },
    getOne(v) {
      console.log(v, 1);
      this.cpNum = v;
      this.$get("relic/relicInspectionArchives/dataAnalyze/" + v).then(
        (res) => {
          // console.log(res, 555);
          this.form = res.data;
           if (res.data==null) {
            // this.restData()
          }else{
            if (this.form.type == 2) {
            this.titleName = "近现代重要史迹及代表性建筑";
          } else {
            this.titleName == "";
          }
          // this.imgsrc=[]
          // if (this.form.photo) {
          //   this.imgsrc = this.form.photo.split(",");
          // }
          
          this.chongzi()
          }
          
          // console.log(this.imgsrc, "this.imgsrc");
        }
      );
    },
    getUnit(v) {
      console.log(v, 2);
      this.cpNum = v;
      this.switchUnit = false;
      // this.companyName = '';
      // this.$router.push("/report/report-list");
      if (this.$local.get("company")) {
        this.companyName = this.$local.get("company").c_name;
        console.log(this.companyName,'this.companyName');
      }
       console.log(this.companyName,'this.companyName');
      this.$get("relic/relicInspectionArchives/dataAnalyze/" + v).then(
        (res) => {
          console.log(res, 555);
          this.form =res.data ;
          if (res.data==null) {
            this.restData()
          }else{
            if (this.form.type == 2) {
            this.titleName = "近现代重要史迹及代表性建筑";
          } else {
            this.titleName == "";
          }
          // this.imgsrc=[]
          
          
          // console.log(this.imgsrc, "this.imgsrc");
          this.$nextTick(()=>{
            this.chongzi()
          })
          }
          
          
        }
      );
    },
    chongzi(){
      this.restData()
      if( this.form.type == 1){
          this.formType="古建筑"
        }else if(this.form.type == 2){
           this.formType="近现代重要史迹及代表性建筑"
        }else if(this.form.type == 3){
           this.formType="古墓葬"
        }else if(this.form.type == 4){
           this.formType="石窟寺及石刻"
        }else if(this.form.type == 5){
           this.formType="古遗址"
        }else{
          this.formType="其它"
        }
         if( this.form.relicRank == 1){
          this.formRelicRank="全国重点"
        }else if(this.form.relicRank == 2){
           this.formRelicRank="省级"
        }else if(this.form.relicRank == 3){
           this.formRelicRank="青岛市级"
        }else if(this.form.relicRank == 4){
           this.formRelicRank="平度市级"
        }else{
          this.formRelicRank="其它"
        }
        if (this.form.photo) {
            this.imgsrc = this.form.photo.split(",");
          }
        console.log(this.form,999999);
        this.formintro=this.form.intro
        
    },
    restData(){
      console.log('wushuju');
      this.formType='暂无数据'
      this.formRelicRank='暂无数据'
      this.formintro='暂无数据'
      this.swiItem1Type="暂无数据"
      this.swiItem1relicRank="暂无数据"
      this.swiItem1intro= '暂无数据'
      this.imgsrc=[]
      
      
    },
    getName(v) {
      console.log(v, 6666666666);
      this.companyName = v;
      this.company = v;
    },
    getDeviceCountGroupType() {
      console.log(this.cpNum,'this.cpNum');
      deviceCountGroupType({ companyNum: this.cpNum }).then((res) => {
        console.log(res, 666661111);
        this.deviceCountGroupTypeList = res.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// @import "../../assets/css/analysisUnit/analysisUnit.css";
.containertContent {
  display: flex;
  width: 100%;
  justify-content: center;
  // height: 100%;
}
.xiahuaxian {
  width: 100vw;
  border-bottom: 1px solid black;
}
.item2 {
  display: flex;
  justify-content: space-between;
  border: 1px solid rgb(33, 150, 243);
  height: 88%;
}
.fisrbase {
  width: 20%;

  margin-top: 15px;
}
.buju {
  display: flex;
}
.containerHome {
  padding: 15px;
  width: 100%;
}
.ziyanse {
  width: 110px;
  font-weight: bold;
  color: rgb(33, 150, 243);
  //   padding: 0 0 15px 0;
}
.item3 {
  width: 80%;
  margin-top: 15px;
  margin-left: 15px;
}
.zhongjian {
  display: flex;
  //   justify-content: space-between;
  margin: 30px 0 0 0;
}
.wenzi {
  width: 50%;
  height: 200px;
  padding: 15px;
  border: 1px solid rgb(33, 150, 243);
  margin: 0 15px 0 0;
}
.dataChartList {
  width: 50%;
  height: 200px;
  padding: 15px;
  border: 1px solid rgb(33, 150, 243);
}
.shengluehao {
  overflow: hidden;
  text-overflow: ellipsis;
  /* 将对象作为弹性伸缩盒子模型显示 */
  display: -webkit-box;
  /* 限制在一个块元素显示的文本的行数 */
  /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
  -webkit-line-clamp: 6;
  /* 设置或检索伸缩盒对象的子元素的排列方式 */
  -webkit-box-orient: vertical;
}
.deviceList {
  display: flex;
  flex-wrap: wrap;
}
.hangzong {
  display: flex;
  padding: 12px 30px;
  margin-left: 30px;
  width: 40%;
}
.bjtc {
  background-color: rgb(211, 211, 211);
  width: 20px;
  height: 20px;
  text-align: center;
  // padding: 10px;
  margin-left: 40px;
  overflow: hidden;
}
.buhuanh {
  overflow: hidden;
  text-overflow: ellipsis; //文本溢出显示省略号
  white-space: nowrap; //文本不会换行
}
.zhaoPhoto {
  width: 260px;
  height: 200px;
  margin: 10px;
}
</style>
